<template>
  <div>
    <h1 class="font-semibold text-xl mb-5 flex justify-between items-center">
      Точки продаж ({{ branches.length }})
      <el-button @click="openCreateBranchDialog" size="small" type="primary">
        Создать
      </el-button>
    </h1>

    <el-table v-loading="loading" :data="branches">
      <el-table-column prop="title" label="Название"></el-table-column>
      <el-table-column
        prop="branch_code"
        label="storeId(kaspi)"
      ></el-table-column>
      <el-table-column
        prop="branch_code_halyk"
        label="storeId(halyk)"
      ></el-table-column>
      <el-table-column prop="city_id" label="Город">
        <template slot-scope="scope">
          {{ getCityTitle(scope.row.city_id) }}
        </template>
      </el-table-column>
      <el-table-column prop="brand" label="Действия">
        <template slot-scope="scope">
          <el-button
            @click.stop="selectBranch(scope.row)"
            size="small"
            plain
            icon="el-icon-edit"
            type="primary"
          ></el-button>
          <el-button
            @click.stop="deleteBranch(scope.row.id)"
            size="small"
            plain
            icon="el-icon-delete"
            type="danger"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="Точка продаж" :visible.sync="dialogVisible" width="30%">
      <el-form label-position="top">
        <el-form-item label="Город">
          <el-select filterable v-model="branch.city_id">
            <el-option
              v-for="city in cities"
              :key="city.id"
              :value="city.id"
              :label="city.title"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Название">
          <el-input v-model="branch.title"></el-input>
        </el-form-item>
        <el-form-item label="StoreId(kaspi)">
          <el-input v-model="branch.branch_code"></el-input>
        </el-form-item>
        <el-form-item label="StoreId(halyk)">
          <el-input v-model="branch.branch_code_halyk"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="loading"
            size="small"
            @click="dialogVisible = false"
          >
            Отмена
          </el-button>
          <el-button
            :disabled="loading"
            type="primary"
            size="small"
            @click="save"
          >
            Сохранить
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBranches,
  createBranch,
  updateBranch,
  deleteBranch,
} from "@/api/branch";
import { getCities } from "@/api/branch";

const emptyBranchData = {
  id: null,
  city_id: null,
  title: null,
  branch_code: null,
  branch_code_halyk: null,
};

export default {
  name: "list",
  data: () => ({
    cities: [],
    branches: [],
    dialogVisible: false,
    branch: Object.assign({}, {}, emptyBranchData),
    loading: false,
  }),
  async created() {
    await this.getBranches();
    await this.getCities();
  },
  methods: {
    async getBranches() {
      this.loading = true;
      this.branches = await getBranches();
      this.loading = false;
    },
    async getCities() {
      this.cities = await getCities();
    },
    openCreateBranchDialog() {
      this.dialogVisible = true;
      this.branch = Object.assign({}, this.branch, emptyBranchData);
    },
    async save() {
      if (this.branch.id) {
        await this.updateBranch();
      } else {
        await this.createBranch();
      }
    },
    async createBranch() {
      this.loading = true;
      try {
        const result = await createBranch(this.branch);
        if (result.success) {
          this.$message.success("Успешно");
          this.dialogVisible = false;
          await this.getBranches();
        } else {
          this.$message.error(`Ошибка ${result.message}`);
        }
      } catch (e) {
        this.$message.error(e.message);
      }
      this.loading = false;
    },
    async updateBranch() {
      this.loading = true;
      try {
        const result = await updateBranch(this.branch.id, this.branch);
        if (result.success) {
          this.$message.success("Успешно");
          this.dialogVisible = false;
          await this.getBranches();
        } else {
          this.$message.error(`Ошибка ${result.message}`);
        }
      } catch (e) {
        this.$message.error(e.message);
      }
      this.loading = false;
    },
    selectBranch(branch) {
      this.dialogVisible = true;
      this.branch = Object.assign({}, this.branch, branch);
    },
    async deleteBranch(id) {
      this.$confirm(
        "Вы действительно хотите удалить. Продолжить?",
        "Внимание",
        {
          confirmButtonText: "Да",
          cancelButtonText: "Отмена",
          type: "warning",
        }
      ).then(async () => {
        await deleteBranch(id);
        await this.getBranches();
      });
    },
    getCityTitle(id) {
      if (this.cities.length > 0) {
        return this.cities.find((c) => c.id === id).title;
      }
      return null;
    },
  },
};
</script>

<style scoped></style>
